  var btan_quiz_results = {     
      //Dehydrated
      "q3:a1,q4:a1" : ["just-act-natural", "just-shut-up-sunkiss-me-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a1,q4:a2" : ["love-at-first-tan-self-tan-mousse", "just-shut-up-sunkiss-me-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a1,q4:a3" : ["too-tan-to-give-a-damn-self-tan-mousse", "plump-up-the-bronze-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a1,q4:a4" : ["i-want-the-darkest-tan-possible-self-tan-mousse", "plump-up-the-bronze-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a1,q4:a5" : ["btan-forever-ever-self-tan-mousse", "just-shut-up-sunkiss-me-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a1,q4:a6" : ["aint-nobody-got-time-for-dat", "just-shut-up-sunkiss-me-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a1,q4:a7" : ["disco-candy-tan", "just-shut-up-sunkiss-me-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a1,q4:a8" : ["just-act-natural", "just-shut-up-sunkiss-me-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a1,q4:a9" : ["from-pasty-to-tasty-self-tan-mousse", "just-shut-up-sunkiss-me-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a1,q4:a10" : ["tanned-af-self-tan-mousse", "just-shut-up-sunkiss-me-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      //Dry
      "q3:a2,q4:a1" : ["just-act-natural", "its-love-gradual-tan-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a2,q4:a2" : ["love-at-first-tan-self-tan-mousse", "its-love-gradual-tan-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a2,q4:a3" : ["too-tan-to-give-a-damn-self-tan-mousse", "plump-up-the-bronze-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a2,q4:a4" : ["i-want-the-darkest-tan-possible-self-tan-mousse", "plump-up-the-bronze-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a2,q4:a5" : ["btan-forever-ever-self-tan-mousse", "its-love-gradual-tan-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a2,q4:a6" : ["aint-nobody-got-time-for-dat", "its-love-gradual-tan-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a2,q4:a7" : ["disco-candy-tan", "its-love-gradual-tan-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a2,q4:a8" : ["just-act-natural", "its-love-gradual-tan-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a2,q4:a9" : ["from-pasty-to-tasty-self-tan-mousse", "its-love-gradual-tan-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a2,q4:a10" : ["tanned-af-self-tan-mousse", "its-love-gradual-tan-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      //Deflated
      "q3:a3,q4:a1" : ["fake-it-till-you-make-it-self-tan-mousse", "plump-up-the-bronze-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a3,q4:a2" : ["love-at-first-tan-self-tan-mousse", "plump-up-the-bronze-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a3,q4:a3" : ["too-tan-to-give-a-damn-self-tan-mousse", "plump-up-the-bronze-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a3,q4:a4" : ["i-want-the-darkest-tan-possible-self-tan-mousse", "plump-up-the-bronze-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a3,q4:a5" : ["btan-forever-ever-self-tan-mousse", "plump-up-the-bronze-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a3,q4:a6" : ["aint-nobody-got-time-for-dat", "plump-up-the-bronze-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a3,q4:a7" : ["disco-candy-tan", "plump-up-the-bronze-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a3,q4:a8" : ["just-act-natural", "plump-up-the-bronze-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a3,q4:a9" : ["from-pasty-to-tasty-self-tan-mousse", "plump-up-the-bronze-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a3,q4:a10" : ["tanned-af-self-tan-mousse", "plump-up-the-bronze-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      //Dull
      "q3:a4,q4:a1" : ["fake-it-till-you-make-it-self-tan-mousse", "plump-up-the-bronze-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a4,q4:a2" : ["love-at-first-tan-self-tan-mousse", "plump-up-the-bronze-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a4,q4:a3" : ["tanned-af-self-tan-mousse", "plump-up-the-bronze-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a4,q4:a4" : ["i-want-the-darkest-tan-possible-self-tan-mousse", "plump-up-the-bronze-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a4,q4:a5" : ["btan-forever-ever-self-tan-mousse", "plump-up-the-bronze-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a4,q4:a6" : ["aint-nobody-got-time-for-dat", "plump-up-the-bronze-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a4,q4:a7" : ["disco-candy-tan", "plump-up-the-bronze-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a4,q4:a8" : ["just-act-natural", "plump-up-the-bronze-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a4,q4:a9" : ["no-sun-required-self-tan-mousse", "plump-up-the-bronze-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a4,q4:a10" : ["tanned-af-self-tan-mousse", "plump-up-the-bronze-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      //Oily
      "q3:a5,q4:a1" : ["fake-it-till-you-make-it-self-tan-mousse", "just-shut-up-sunkiss-me-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a5,q4:a2" : ["love-at-first-tan-self-tan-mousse", "just-shut-up-sunkiss-me-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a5,q4:a3" : ["tanned-af-self-tan-mousse", "just-shut-up-sunkiss-me-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a5,q4:a4" : ["i-want-the-darkest-tan-possible-self-tan-mousse", "just-shut-up-sunkiss-me-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a5,q4:a5" : ["btan-forever-ever-self-tan-mousse", "just-shut-up-sunkiss-me-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a5,q4:a6" : ["aint-nobody-got-time-for-dat", "just-shut-up-sunkiss-me-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a5,q4:a7" : ["disco-candy-tan", "just-shut-up-sunkiss-me-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a5,q4:a8" : ["just-act-natural", "just-shut-up-sunkiss-me-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a5,q4:a9" : ["from-pasty-to-tasty-self-tan-mousse", "just-shut-up-sunkiss-me-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a5,q4:a10" : ["tanned-af-self-tan-mousse", "just-shut-up-sunkiss-me-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      //Uneven
      "q3:a6,q4:a1" : ["fake-it-till-you-make-it-self-tan-mousse", "plump-up-the-bronze-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a6,q4:a2" : ["love-at-first-tan-self-tan-mousse", "plump-up-the-bronze-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a6,q4:a3" : ["tanned-af-self-tan-mousse", "plump-up-the-bronze-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a6,q4:a4" : ["i-want-the-darkest-tan-possible-self-tan-mousse", "plump-up-the-bronze-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a6,q4:a5" : ["btan-forever-ever-self-tan-mousse", "plump-up-the-bronze-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a6,q4:a6" : ["aint-nobody-got-time-for-dat", "plump-up-the-bronze-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a6,q4:a7" : ["disco-candy-tan", "plump-up-the-bronze-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a6,q4:a8" : ["just-act-natural", "plump-up-the-bronze-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a6,q4:a9" : ["no-sun-required-self-tan-mousse", "plump-up-the-bronze-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a6,q4:a10" : ["tanned-af-self-tan-mousse", "plump-up-the-bronze-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      //Normal
      "q3:a7,q4:a1" : ["fake-it-till-you-make-it-self-tan-mousse", "plump-up-the-bronze-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a7,q4:a2" : ["love-at-first-tan-self-tan-mousse", "plump-up-the-bronze-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a7,q4:a3" : ["tanned-af-self-tan-mousse", "plump-up-the-bronze-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a7,q4:a4" : ["i-want-the-darkest-tan-possible-self-tan-mousse", "plump-up-the-bronze-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a7,q4:a5" : ["btan-forever-ever-self-tan-mousse", "plump-up-the-bronze-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a7,q4:a6" : ["aint-nobody-got-time-for-dat", "plump-up-the-bronze-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a7,q4:a7" : ["disco-candy-tan", "plump-up-the-bronze-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a7,q4:a8" : ["just-act-natural", "plump-up-the-bronze-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a7,q4:a9" : ["no-sun-required-self-tan-mousse", "plump-up-the-bronze-lotion", "gimme-the-glow-down", "tan-application-mitt"],
      "q3:a7,q4:a10" : ["tanned-af-self-tan-mousse", "plump-up-the-bronze-lotion", "gimme-the-glow-down", "tan-application-mitt"],
  }

  var replacemets = [
    "tanned-af-self-tan-mousse", "plump-up-the-bronze-lotion", "you-glow-girl", "weve-got-your-back"
  ];
  
  $('.answer-tile input').change(function() {
    var $par  = $(this).closest('.answers');
    var $sel = $par.find('.select-icon'); 
    $sel.fadeIn();
    var $input = $par.find('[type="radio"]:checked').parent();
    var left = $input.position().left + $input.width() + parseInt($input.css('margin-left')) - 42;
    var top = $input.position().top + $input.height()/2;
    $sel.css('left', left+'px').css('top', top+'px');
    $('.quiz-form .btn.sf-next').addClass('active');
  });

  $(window).resize(function() {
    positionSelect();
  });

  function positionSelect() {    
    var $par  = $('.question.active').find('.answers');
    var $sel = $par.find('.select-icon'); 
    var $input = $par.find('[type="radio"]:checked').parent();
    if (!$input.length) {
      $sel.hide();
      $('.quiz-form .btn.sf-next').removeClass('active');
      return;
    }
    var left = $input.position().left + $input.width() + parseInt($input.css('margin-left')) - 42;
    var top = $input.position().top + $input.height()/2;
    $sel.css('left', left+'px').css('top', top+'px');
    $('.quiz-form .btn.sf-next').addClass('active');  
  }

  $(document).on('click', '.quiz-form .btn.sf-prev, .quiz-form .btn.sf-next.active', function(e) {
    e.preventDefault();
    e.stopPropagation();
    var $q = $('.quiz-form .question.active');
    var current_i = $q.index();
    var step_change = false;
    if($(this).hasClass('sf-next')) {    
      var step = current_i+2; 
      if(step === 4) {
        $('.quiz-form .btn.sf-next').text('finish');
      }   
      step_change = true;
      if(step>4) {
        quizResults();
        return;
      }
    } else if($(this).hasClass('sf-prev') && current_i > 0) {
      var step = current_i;  
      if(step === 3) {
        $('.quiz-form .btn.sf-next').text('next');
      }
      step_change = true;
    }

    if(step_change) {
      $q.removeClass('active'); 
      $('.quiz-progress-title span').text(step);
      $('.question[data-id="q'+step+'"]').addClass('active'); 
      $('.quiz-form .btn.sf-next').removeClass('active');  
      $.when(
        $('.quiz-form-progress .active').removeClass('active')
      ).then(
        $.when(
          $('.quiz-form-progress li:lt('+step+')').addClass('active')
        ).then(
          function() {          
            if($('.question.active').find('[type="radio"]:checked').length > 0) {
              $('.quiz-form .btn.sf-next').addClass('active');        
            } 
          }
        )
      );    
    }
  });

  function buildProductItem(product, variant) {
    var html = '';
    html +=  '<div class="no_crop_image grid-item col-xs-6 col-sm-3 col-md-3 col-lg-3">'
    html +=  '  <div class="inner product-item  wow fadeIn" data-wow-delay="0ms" id="product-'+product.id+'">'
    html +=  '   <div class="inner-top">'
    html +=  '     <div class="product-top">'
    html +=  '       <div class="product-image">'
    html +=  '         <a href="'+product.url+'" class="product-grid-image">' 
    html +=  '           <img class="imgfront lazyload" data-src="'+product.images[0]+'" alt="" width="950" height="1200">'
    html +=  '           <img class="imgback lazyload" data-src="'+product.images[product.images.length-1]+'" alt="" />'
    html +=  '           <div class="hover">'
    html +=  '             <p class="viewme">VIEW MORE</p>'
    html +=  '           </div>' 
    html +=  '         </a>'
    html +=  '       </div>'
    html +=  '     </div>'  
    html +=  '     <div class="product-bottom">'
    html +=  '       <div class="product-bottom-hold">'
    html +=  '         <a class="product-title" href="'+product.url+'">'+product.title+'</a>'
    if(typeof product.reviews !== 'undefined' && typeof product.reviews.reviewCount !== 'undefined') {
    var reviewPercent = 100 * (parseFloat(product.reviews.reviewAverageValue)/5.0);
    html +=  '           <div class="okeReviews-hide-star-number">'
	html +=  '             <div data-oke-reviews-product-listing-rating>'
    html +=  '               <div data-oke-reviews-version="2.16.1" class="okeReviews okeReviews--theme">'
    html +=  '                 <div class="okeReviews-reviewsSummary js-okeReviews-reviewsSummary" data-oke-ga-click-action="Star Rating Summary Click" data-oke-ga-click-label="'+product.title+'">'
    html +=  '                   <div class="okeReviews-reviewsSummary-starRating">'
    html +=  '                     <span class="okeReviews-starRating okeReviews-starRating--small">'
    html +=  '                       <span class="okeReviews-a11yText">Rated '+product.reviews.reviewAverageValue+' out of 5</span>'
    html +=  '                       <span class="okeReviews-starRating-indicator" role="presentation">'
    html +=  '                         <span class="okeReviews-starRating-indicator-layer"></span>'
    html +=  '                         <span class="okeReviews-starRating-indicator-layer okeReviews-starRating-indicator-layer--foreground" style="width: '+reviewPercent+'%"></span>'
    html +=  '                       </span>'
    html +=  '                     </span>'
    html +=  '                   </div>'
    html +=  '                   <div class="okeReviews-reviewsSummary-ratingCount">'
    html +=  '                     <span aria-hidden="true">'+product.reviews.reviewCount+' Reviews</span>'
    html +=  '                     <span class="okeReviews-a11yText">Based on '+product.reviews.reviewCount+' reviews</span>'
    html +=  '                   </div>'
    html +=  '                 </div>'
    html +=  '               </div>'
    html +=  '               <span class="okeReviews okeReviews-listing-reviewCount">('+product.reviews.reviewCount+' reviews)</span>'
    html +=  '             </div>'
    html +=  '             <span class="okeReviews-custom-star-number">('+product.reviews.reviewCount+')</span>'
	html +=  '           </div>'
    }
    html +=  '         </div>'
    html +=  '         <div class="price-box">'
    html +=  '           <div class="action">'
    html +=  '             <form action="/cart/add" data-productid="'+product.id+'" method="post" class="variants" id="product-actions-'+product.id+'" enctype="multipart/form-data" style="padding:0px;">'
    html +=  '               <input type="hidden" name="id" data-productid="'+product.id+'" value="'+variant.id+'" />'
    html +=  '               <input type="hidden" name="quantity" value="1" />'   
    html +=  '               <button type="submit" class="btn add-to-cart-btn" id="product-add-to-cart">'
    html +=  '                 <span class>Add to Cart</span>'
    html +=  '                <div class="line"></div>'    
    html +=  '                <p class="regular-product">'
    html +=  '                  <span>'+Shopify.formatMoney(variant.price, money_format_type)+'</span>'
    html +=  '                </p>' 
    html +=  '              <div class="backdrop"></div>'
    html +=  '                </button>'
    html +=  '             </form>'
    html +=  '            </div>'
    html +=  '         </div>'//price-box
    html +=  '       </div>'//product-bottom
    html +=  '     </div>'//inner-top
    html +=  '   </div>'//product-item
    html +=  '</div>'//no-crop
    return html;
  }
    
  var quizRun = 0;
  var quizResultTimer;

  function quizMessage(name, fallback) {
    return $('.btan-quiz-page').attr('data-' + name) || fallback;
  }

  function availableQuizVariant(product) {
    if (!product || !Array.isArray(product.variants)) return null;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].available) return product.variants[i];
    }
    return null;
  }

  function loadQuizProduct(handle, replacement) {
    var result = $.Deferred();
    function finish(product) {
      var variant = availableQuizVariant(product);
      result.resolve(variant ? {product: product, variant: variant} : null);
    }
    function request(productHandle) {
      return $.ajax({
        url: window.Shopify.routes.root + 'products/' + productHandle + '.js',
        dataType: 'json',
        timeout: 15000
      });
    }
    request(handle).done(finish).fail(function() {
      if (replacement && replacement !== handle) {
        request(replacement).done(finish).fail(function() { result.resolve(null); });
      } else {
        result.resolve(null);
      }
    });
    return result.promise();
  }

  function quizResults() {
    var run = ++quizRun;
    clearTimeout(quizResultTimer);
    $('.quiz-form, .subscribe-step, .results-step').hide();
    $('.loading-step').show();
    $('#quiz-cart-error, #quiz-availability-message').empty().hide();
    $('.product-suggestions').empty();
    $('#add-bundle').prop('disabled', true);
    var answers = [];
    $('.quiz-form .question:not([data-skip="1"])').each(function() {
      answers.push($(this).data('id') + ':' + $(this).find('[name^="quiz_form"]:checked').val());
    });
    var products = btan_quiz_results[answers.join(',')] || [];
    var items = [];
    var requests = products.map(function(handle, index) {
      return loadQuizProduct(handle, replacemets[index]).done(function(item) { items[index] = item; });
    });
    $.when.apply(null, requests).done(function() {
      if (run !== quizRun) return;
      var seen = {};
      var availableItems = items.filter(function(item) {
        if (!item || seen[item.variant.id]) return false;
        seen[item.variant.id] = true;
        return true;
      });
      loadProductsData(availableItems, products.length, run);
    });
  }

  function loadProductsData(items, expectedCount, run) {
    var reviews = items.map(function(item) {
      // Reviews are optional; a failed review request must still release results.
      var ready = $.Deferred();
      $.ajax({
        url: 'https://minetanbodyskin.com/order-tracking/product-meta.php',
        data: {id: item.product.id, store: 'uk'},
        dataType: 'json',
        timeout: 10000
      }).done(function(data) {
        if (data && data.success == 1 && data.data) item.product.reviews = data.data;
      }).always(function() { ready.resolve(); });
      return ready.promise();
    });
    $.when.apply(null, reviews).done(function() {
      if (run !== quizRun) return;
      var html = '';
      var bundlePrice = 0;
      items.forEach(function(item) {
        bundlePrice += Number(item.variant.price);
        html += buildProductItem(item.product, item.variant);
      });
      $('#num-in-bundle').text(items.length);
      var discountEligible = items.length >= 4;
      $('.bundle-discount .sticker h3, .bundle-discount .sticker p, .bundle-discount .notice-2, .bundle-discount .discount-code, .bundle-discount .notice-3, #bundle-old-price').toggle(discountEligible);
      $('#add-bundle').attr('data-discount-eligible', discountEligible ? '1' : '0');
      $('#bundle-old-price').text(Shopify.formatMoney(bundlePrice, money_format_type));
      $('#bundle-price').text(Shopify.formatMoney(discountEligible ? bundlePrice * 0.85 : bundlePrice, money_format_type));
      $('.product-suggestions').html(html);
      $('#add-bundle').prop('disabled', !items.length);
      if (items.length < expectedCount || !items.length) {
        $('#quiz-availability-message').text(items.length
          ? quizMessage('available-only', 'Some recommendations are unavailable. Your bundle contains only the available items shown below.')
          : quizMessage('no-products', 'Your recommendations are currently unavailable. Please try again later.')).show();
      }
      quizResultTimer = setTimeout(function() {
        if (run !== quizRun) return;
        $('.loading-step').hide();
        $('.subscribe-step').show();
      }, 3000);
    });
  }


  $(document).on('click', '.subscribe-step .close-btn, .subscribe-step .skip-subscribe', function(e) {
    e.preventDefault();
    $('.subscribe-step').hide();
    $('.results-step').show();    
  });

  $(document).on('click', '.retake-link', function(e) {
    e.preventDefault();
    quizRun++;
    clearTimeout(quizResultTimer);
    $('.loading-step, .subscribe-step').hide();
    $('#quiz-cart-error, #quiz-availability-message').empty().hide();
    $('.product-suggestions').empty();
    $('#add-bundle').prop('disabled', true);
    $('.quiz-form').show();
    $('.results-step').hide();
    $('.quiz-form .btn.sf-next').text('next'); 
    $('.quiz-form .btn.sf-next').removeClass('active');
    $('.quiz-form-progress .active:not(:first-child)').removeClass('active');    
    $('.quiz-progress-title span').text(1);
    $('.question.active').removeClass('active'); 
    $('.question[data-id="q1"]').addClass('active'); 
    $('.question').find('.select-icon').hide();
    $('.question input:checked').prop('checked', false);
  }); 

  function addQuizItems(items, $button, isBundle) {
    if ($button.prop('disabled') || !items.length) return;
    var $error = $('#quiz-cart-error');
    $error.empty().hide();
    $button.prop('disabled', true);
    $.ajax({
      type: 'POST',
      url: window.Shopify.routes.root + 'cart/add.js',
      data: {items: items},
      dataType: 'json',
      timeout: 20000,
      success: function() {
        if (isBundle && $('#add-bundle').attr('data-discount-eligible') === '1') {
          // A new cart needs its token before the existing discount helper can use it.
          $.ajax({url: window.Shopify.routes.root + 'cart.js', dataType: 'json', timeout: 10000})
            .done(function(cart) {
              cart_id = cart.token;
              applyDiscount($('#discount-code-value').text());
            });
        }
        fetchCart();
        showCartDrawer();
      },
      error: function(xhr) {
        var response = xhr.responseJSON;
        if (!response && xhr.responseText) {
          try { response = JSON.parse(xhr.responseText); } catch (error) {}
        }
        var message = response && (response.description || response.message);
        if (typeof message !== 'string' || /jjj/i.test(message) || /<[^>]*>/.test(message)) {
          message = quizMessage('cart-error', 'We could not add these items to your cart. Stock may have changed. Please retake the quiz or try again.');
        }
        $error.text(message).show().trigger('focus');
      },
      complete: function() { $button.prop('disabled', false); }
    });
  }

  $(document).on('click', '.product-suggestions #product-add-to-cart', function(e) {
    e.preventDefault();
    addQuizItems([{quantity: 1, id: $(this).closest('form').find('[name="id"]').val()}], $(this), false);
  });

  $(document).on('click', '#add-bundle', function(e) {
    e.preventDefault();
    var items = [];
    $('.product-suggestions [name="id"]').each(function() {
      items.push({quantity: 1, id: $(this).val()});
    });
    addQuizItems(items, $(this), true);
  });

  function sendDataToKlaviyo(email) {
    let input = {
      "email": email,
      "experience": $('[name="quiz_form[q1]"]:checked').next().text(),
      "skin tone": $('[name="quiz_form[q2]"]:checked').next().text(),
      "skin type": $('[name="quiz_form[q3]"]:checked').next().text(),
      "goal": $('[name="quiz_form[q4]"]:checked').next().text(),
    };
    klaviyo.identify(input);
    return;
  }

  window.addEventListener("klaviyoForms", function(e) { 
      if (e.detail.type == 'submit' && e.detail.formId == 'TpykfB') { 
        sendDataToKlaviyo(e.detail.metaData.$email);
        $('.subscribe-step').hide();
        $('.results-step').show();   
      }
  });